<template>
    <div style="height: 100%; overflow-y: hidden">
        <van-cell-group>
            <van-field
                    v-model="formData.nameOrPhone"
                    label="用户名"
                    placeholder="请输入手机号/用户名"
                    clearable
            />
            <van-field
                    type="password"
                    v-model="formData.password"
                    label="密码"
                    placeholder="请输入密码"
                    clearable
            />
        </van-cell-group>
        <div style="padding: 20px; text-align:center" >
            <van-button type="danger" round size="large"  @click.stop="save">登录</van-button>

            <van-button   style="margin-top: 20px;" round   @click.stop="loginShow=true">手机验证码登录</van-button>
        </div> 
        <div class="cert-status login-success" :style="{top:success?'0px':'1000px'}">
            <div class="cert-status-content">
                <div class="cert-status-icon-success"></div>
                <p class="cert-status-title">{{phone}}</p>
                <p class="cert-status-title">登陆成功</p>
            </div>
        </div>


        <LoginDialog
        :show="loginShow"
        @loginSuccess="loginSuccess"
        @loginCancel="loginCancel"
        />
    </div>
</template>

<style scoped="">
</style>
<script>
    import {
        Cell, CellGroup,NoticeBar,Field,Button
    } from 'vant';
    import LoginDialog from '@/components/LoginDialog.vue';
    export default {
        name: 'loginByUsername',
        components: {
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [NoticeBar.name]: NoticeBar,
            [Button.name]: Button,
            LoginDialog,
        },
        data: function () {
            return {
                formData:{
                    nameOrPhone:'',
                    password:'',
                },
                phone:'',
                success: false,
                loginShow:false,
                fileList:[]
            }
        },
        mounted: function () {
            document.title = "用户登录";
        },
        methods: {
            save(){
                var that = this;
                this.$api.get("/api/index/login", that.formData, r => {
                    // that.$toast.fail('成功'); 
                    that.phone =  r.data.name;
                    that.success = true;
                    appEvent({
                        name: 'login',
                        query: {
                            token:r.data.token,
                            phone:r.data.phone,
                        }
                    }); 
                    localStorage.setItem('_token', r.data.token);
                    setTimeout(function () {
                        rbLink({ 
                            "name":'PageDianxin'
                        },'replace');
                    },1000)
                });
            },

            loginSuccess(res) {
            console.log("-------登录成功--------", res);
            this.loginShow = false; 
            this.$router.replace({ name: "PageDianxin" });
            },

            loginCancel() {
            console.log("-------取消登录--------");
            // this.loginShow = false;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// loginDianxin.vue?20d9f1c6